// extracted by mini-css-extract-plugin
module.exports = {"containerDiv":"Auth_containerDiv__2iURN","form":"Auth_form__3QwUj"};